const trimTrailingSlashes = path => (path.trim().replace(/\/+$/, ''));

/* eslint-disable no-undef,camelcase */
__webpack_public_path__ = `${trimTrailingSlashes(window.resourceBasePath)}/`;

export const RAW_BASE_PATH = __webpack_public_path__;
export const AUTH_SERVICE_URL = window.authServiceUrl;
export const AUTHORIZE_ENDPOINT = window.authEndpoint;
export const ACR_VALUES = window.acrValues;
export const CHECK_NONCE = (window.checkNonce === 'true');
export const TOKEN_ENDPOINT = window.tokenEndpoint;
export const REVOKE_ENDPOINT = window.revokeEndpoint;
